import { useEffect, useState } from "react";

/** Reaktiv media query (SSR-trygg). Eks: useMediaQuery("(min-width: 1024px)") */
export function useMediaQuery(query) {
  const get = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    if (mql.addEventListener) mql.addEventListener("change", onChange); else mql.addListener(onChange);
    return () => { if (mql.removeEventListener) mql.removeEventListener("change", onChange); else mql.removeListener(onChange); };
  }, [query]);
  return matches;
}

/** Tailwind `lg`-brekkpunkt (1024px) – brukes for å rendre én layout om gangen (unngår doble DOM-noder/testid-er). */
export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");
